/**
 * Created by Patrick on 7/5/2019.
 */

import React, { Component } from 'react';
import moment from 'moment';
import LoadingSpinner from '../components/LoadingSpinner';
import Row from '../components/Row';
import NoRecordsFound from '../components/NoRecordsFound';

class TestInstanceList extends Component {
    headers = [
        {
            key: 'name',
            name: 'Name',
            width: 4,
        },
        {
            key: 'status',
            name: 'Status',
            width: 2,
        },
        {
            key: 'numberDevices',
            name: 'Count',
            width: 1,
        },
        {
            key: 'mode',
            name: 'Mode',
            width: 1,
        },
        {
            key: 'creationTime',
            name: 'Age',
            width: 2,
        },
        {
            key: 'edit',
            name: 'Edit',
            sortable: false,
            width: 1,
        },
        {
            key: 'clone',
            name: 'Clone',
            sortable: false,
            width: 1,
        },
        {
            key: 'delete',
            name: 'Delete',
            sortable: false,
            width: 1,
        }
    ];

    modeIconMap = {
        'Battery-only': <span className="glyphicon glyphicon-flash" />,
        'Host-only': <span className="glyphicon glyphicon-phone" />,
        Both: (
            <span className="flex-center">
                <span className="glyphicon glyphicon-flash" />
                <span className="glyphicon glyphicon-phone" />
            </span>
        ),
    };

    renderTableHeaders = () => {
        const { updateSortState, sort, arrow } = this.props;

        return this.headers.map(({ key, name, width, sortable }) => {
            if (sortable === false) {
                return (
                    <th key={key}>
                        <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                    </th>
                );
            }

            return (
                <th key={key} onClick={() => updateSortState(key)}>
                    <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`}>
                        {name} {sort === key && arrow}
                    </div>
                </th>
            );
        });
    };

    renderTableRows = () => {
        const {
            testInstances,
            selectedInstanceId,
            deleteTestInstance,
            checkTestState,
            getSingleTestInstance,
            showEditTestInstance,
            cloneTestInstance
        } = this.props;

        if (testInstances.length) {
            return testInstances.map(instance => {

                // Enable Edit button if a TestInstance has not been started.
                const enableEditButton = !instance.startTime;
                const editTestInstance = <a className="icon-button" onClick={() => showEditTestInstance(instance._id)}><span className="glyphicon glyphicon-pencil edit-button flex-center" /></a>
                const status = checkTestState(instance);

                // Select what fields should be displayed in the row
                let selectedFields = {
                    name: instance.name,
                    status,
                    numberDevices: instance.devices.length,
                    mode: this.modeIconMap[instance.mode],
                    creationTime: moment(instance.creationTime)
                        .fromNow()
                        .split(' ago')[0],
                    edit: enableEditButton ? editTestInstance : <span>-</span>
                };

                const allowDelete = status !== "In Progress" && status !== "Initialising";
                if(!allowDelete){
                    selectedFields = {
                        ...selectedFields,
                        clone: <span className="table-row__link" onClick={() => cloneTestInstance(instance._id)}>CLONE</span>,
                        deletePlaceholder: <span>-</span>
                    }
                } else {
                    selectedFields = {
                        ...selectedFields,
                        clone: <span className="table-row__link" onClick={() => cloneTestInstance(instance._id)}>CLONE</span>
                    }    
                }

                return (
                    <Row
                        key={instance._id}
                        data={selectedFields}
                        isActive={selectedInstanceId === instance._id}
                        onClick={() => getSingleTestInstance(instance._id)}
                        onDelete={allowDelete ? () => deleteTestInstance(instance._id) : undefined}
                    />
                );
            });
        }

        return <NoRecordsFound />;
    };

    render() {
        const { isLoading } = this.props;

        return (
            <div className="test-instance-list">
                {isLoading ? (
                    <div className="flex-center">
                        <LoadingSpinner />
                    </div>
                ) : (
                    <table className="table">
                        <thead className="test-instance-details-head">
                            <tr>{this.renderTableHeaders()}</tr>
                        </thead>
                        <tbody>{this.renderTableRows()}</tbody>
                    </table>
                )}
            </div>
        ); // return
    } // render
} // TestInstanceList

export default TestInstanceList;
